import { keepPreviousData } from '@tanstack/react-query';
import { TWO_MINUTES_IN_MILLISECONDS } from 'mdc-constants';
import { useGraphQLClient } from 'providers';
import { GetRelatedUsersBoatsVariables, useGetRelatedUsersBoats } from '../graphql';
import { useQueryStatusLogging } from './useQueryStatusLogging';

export default function useRelatedUsersBoats(variables: GetRelatedUsersBoatsVariables) {
  const { graphQLClient } = useGraphQLClient();

  const queryInfo = useGetRelatedUsersBoats(graphQLClient, variables, {
    gcTime: TWO_MINUTES_IN_MILLISECONDS,
    staleTime: TWO_MINUTES_IN_MILLISECONDS,
    placeholderData: keepPreviousData,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    enabled: !!variables.id,
  });

  useQueryStatusLogging(queryInfo, 'getRelatedUsersBoats');

  return {
    ...queryInfo,
  };
}
